<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Export to Excel</p>
        </header>
        <section class="modal-card-body">
            <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
            </b-notification>
            <b-message type="is-info" has-icon icon-size="is-small">
                Export metric values and final scores to a spreadsheet for the selected date period.
            </b-message>
            <b-field horizontal label="Date Period" position="is-centered">
                <b-select class="is-pulled-left" v-model="selectedDisplayPeriod" v-if="availableDisplayPeriods.length">
                    <option v-for="displayPeriod in availableDisplayPeriods" :value="displayPeriod" :key="displayPeriod.key">
                        {{ displayPeriod.value }}
                    </option>
                </b-select>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <button type="button" class="button" @click="close">Close</button>
            <button type="button" class="button is-primary" @click="exportToExcel" :disabled="isExporting">
                Export
                <i v-if="isExporting" class="fas fa-spinner fa-spin is-small extra-margin"></i>
            </button>
        </footer>
    </div>
</template>

<script>
import { snapshotChartHelperService } from '@/services/snapshot-chart-helper-service';
import { exporterService } from '@/services/exporter-service';
import { excelReportService } from '@/services/excel-report-service';
export default {
    name: 'ExportExcelReport',
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            isExporting: false,
            errorMessage: '',
            availableDisplayPeriods: [],
            selectedDisplayPeriod: ''
        };
    },
    created () {
        this.availableDisplayPeriods = snapshotChartHelperService.buildAvailableDisplayPeriods(this.project.metrics, this.project.averageMetricsForEntireRange,
            this.project.period, this.project.daySmoothing);
        if (this.availableDisplayPeriods && this.availableDisplayPeriods.length > 0) {
            this.selectedDisplayPeriod = this.availableDisplayPeriods[0];
        }
    },
    methods: {
        async exportToExcel () {
            this.errorMessage = '';
            this.isExporting = true;

            let workbookRequest = excelReportService.buildWorkbookRequest(this.project, this.selectedDisplayPeriod);

            try {
                await exporterService.exportToExcel(workbookRequest);
            } catch (error) {
                console.log(error);
                this.errorMessage = 'Failed to export to Excel';
            } finally {
                this.isExporting = false;
            }
        },
        close () {
            this.$parent.close();
        }
    }
};

</script>

<style lang="scss" scoped>
.modal-card-foot {
    justify-content: flex-end;

    .button.is-pushed-left {
        margin-right: auto;
    }
}

.extra-margin {
    margin-left: 5px;
}
</style>
